import loan from './loan/index';
import client from './client/index';

const stateSelectors = {
    loan,
    client
};

export default stateSelectors;